import { sendTestMatomoEvent } from "./matomoTest";

// Simple in-memory dedupe store to prevent duplicate events firing rapidly
const _recentMatomoEvents = {};

export const sendMatomo = async (action, itemDetails, data,sourceContext) => {
    let mediaType;

    console.log("first12", action, itemDetails, data);

    const category = data?.category_title
    const mediaType1 = getMediaType1(itemDetails);
    const id = itemDetails?.id || data?.id;
    const title = itemDetails?.title || data?.title ;
    const generes = data?.genres || data?.genre_titles || itemDetails?.genres || itemDetails?.genre_titles || "No genres";

    if (action === "ContentDetailPage") {
      // View
      let eventCategory = "ContentDetailPage";
      let eventAction = "View";
      const eventName = category === "Photos" || category === "Games" ? `${id}/${title}` : `${id}/${title}(${mediaType1})`;
      console.log(eventName,"checkingMediaType")

      await sendTestMatomoEvent({
        url: "details",
        eventCategory,
        eventAction,
        eventName,
        sourceContext: sourceContext || "",
      });

      const publisherDetails = `${itemDetails?.publisher_id}/${itemDetails?.publisher_name}`;

      // Interaction
      await sendTestMatomoEvent(
        {
          action_name: `${id}/${title} - ${generes}`,
        },
        {
          eventType: "content_interaction",
          c_i: "Content Detail Page/View",
          pubHouse: publisherDetails,
        }
      );

      // Impression
      await sendTestMatomoEvent(
        {
          action_name: `${id}/${title} - ${generes}`,
        },
        { eventType: "content_impression" }
      );

    } else if (action === "LiveRadio") {
      await sendTestMatomoEvent({
        eventCategory: "LiveRadio",
        eventAction: "Selected",
        eventName: `${data?.id}/${data?.title}`,
        url: "details",
      });
    } else if (action === "LiveChannel") {
      await sendTestMatomoEvent({
        eventCategory: "LiveChannel",
        eventAction: "Selected",
        eventName: `${data?.id}/${data?.title}`,
        url: "details",
      });
    } else if (action === "Image") {
      sendTestMatomoEvent({
        eventCategory: "Image",
        eventAction: "Close",
        eventName: `${itemDetails?.id}/${itemDetails?.title}`,
        sourceContext: sourceContext || "",
      });
    }
};

const getMediaType = (categoryTitle) => {
  switch (categoryTitle) {
    case "TV Channels":
    case "Live":
      return "LiveChannel";
    case "Movies":
    case "Shows":
    case "Shorts":  
    case "Documentaries":
      return "Video";
    case "Radio Channels":
      return "Live Radio";
    case "Audio":
      return "Audio";
    case "Photos":
      return "Image";
    case "Games":
      return "Games";  
    default:
      return "";
  }
};

const getMediaType1 = (itemDetails) => {
  if (!itemDetails) return "Unknown";

  const { type, is_paid } = itemDetails;
  console.log(type,is_paid,itemDetails,"checkingMediaType1")

  if (type === 1) return "AOD";

  if (type === 0) {
    switch (is_paid) {
      case 0:
        return "VOD";
      case 1:  
        return "SVOD";
      case 2:
      case 3:  
        return "TVOD";
      default:
        return "Unknown";
    }
  }

  return "Unknown";
};


export const sendEvent = async ({
  action,
  isReadMore,
  selectedItem,
  selectedIndex,
  itemDetails,
}) => {
  const item = itemDetails; 
  const mediaType = getMediaType(item?.category_title);
  const mediaType1 = getMediaType1(itemDetails);

  console.log(action,selectedItem,itemDetails,"checkingEvent")

  switch (action) {
    /* ---------------- DESCRIPTION ---------------- */
    case "Description":
      return sendTestMatomoEvent({
        eventCategory: "Description",
        eventAction: "Description",
        eventName: isReadMore ? "ReadMore" : "ReadLess",
        // url: pageName,
      });

    /* ---------------- SESSION TIMEOUT ---------------- */
    case "SessionTimedOut":
      return sendTestMatomoEvent({
        eventCategory: "SessionTimedOut",
        eventAction: "Logout",
        eventName: window.APIENDPOINT,
      });

    /* ---------------- REMIND ME POPUP ---------------- */
    case "RemindMePopup":
      if (!item) return; // this event needs itemDetails

      return sendTestMatomoEvent({
        eventCategory: "RemindMePopup",
        eventAction: "Select",
        eventName: `ComingSoon/${item.id}/${item.title}(Disable)`,
        // url: pageName,
      });

    /* ---------------- CONTENT DETAIL PAGE ---------------- */
    case "ContentDetailPage":
      if (!item || !selectedItem) return;

      return sendTestMatomoEvent({
        eventCategory: "ContentDetailPage",
        eventAction: "SeasonSelect",
        eventName: `${item.id}/${item.title}(${mediaType})/${selectedItem.id}/${selectedIndex + 1}`,        // url: pageName,
      });

      /* ---------------- EPISODE SELECT ---------------- */

      case "EpisodeSelect":
      if (!item) return;
      return sendTestMatomoEvent({
        eventCategory: "ContentDetailPage",
        eventAction: "EpisodeSelect",
        eventName: `${item.id}/${item.title}(${mediaType1})/${selectedItem?.season_id}/${item?.season[0]?.number}/${selectedItem?.id}/${selectedItem?.title}`,
        // url: pageName,
      });


      case "HowDoIWatchPopup":
      if (!item) return;
      return sendTestMatomoEvent({
        eventCategory: "HowDoIWatchPopup",
        eventAction: "View",
      });

      /* ---------------- SIMILAR TO THIS ---------------- */
    case "SimilarToThis":
      if (!item) return;
      try {
        const key = `SimilarToThis_${item?.id || ""}`;
        const now = Date.now();
        const last = _recentMatomoEvents[key];
        if (last && now - last < 2000) {
          return; // already sent recently
        }
        _recentMatomoEvents[key] = now;
      } catch (e) {
        // ignore dedupe errors and proceed to send
      }
      return sendTestMatomoEvent({
        eventCategory: `SimilarToThis`,
        eventAction: `ContentSelected`,
        eventName: `(${mediaType})${item?.id}/${item?.title}`,
      });

    /* ---------------- DEFAULT ---------------- */
    default:
      return;
  }
};


export const sendEventAction = async ({action, type,item,sourceContext} ) => {
  console.log("chekcingAction1",action,type,item,sourceContext)
  if (!item) return;

  let category = "";
  let contentType = "";
  let actionType = "";
  let eventCategory = "";
  let c_i = "";

  const id = item?.id ||  item?.show_id; 
  const title = item?.title;
  const generes = item?.genres ? item.genres : item?.genre_titles || "No genres";

  const eventName = `${id}/${title}`;
  const actionName = `${id}/${title} - ${generes}`;

  if (type === "likeDislike") {
    // Normalize like/dislike action
    actionType =
      action.toLowerCase() === "like" ? "LikeEnable" : "DislikeEnable";

    if (item?.type === 0 || item?.media_type === 0) {
      category = "RateVideo";
      contentType = "Video";
    } else if (item?.type === 1 || item?.media_type === 1) {
      category = "RateAudio";
      contentType = "Audio";
    } else if (
      item?.type === 4 ||
      item?.media_type === 4 ||
      item?.type === 7 ||
      item?.media_type === 7
    ) {
      category = "Image";
      contentType = "Image";
    } else {
      return; // unknown type
    }

    eventCategory = category;
    c_i = `${contentType}/${actionType}`;
  } 
  
  else if (type === "watchlist") {
    if (!["Add", "Delete"].includes(action)) return;

    eventCategory = "Watchlist";
    actionType = action; // Add / Delete
    c_i = `Watchlist/${action}`;
  }

  // Base Event
  await sendTestMatomoEvent({
    eventCategory:eventCategory,
    eventAction: actionType,
    eventName:eventName,
    sourceContext: sourceContext || "",
    // url: pageName,
  });

  // Content Interaction
  await sendTestMatomoEvent(
    { action_name: actionName },
    { eventType: "content_interaction", c_i }
  );

  // Content Impression
  await sendTestMatomoEvent(
    { action_name: actionName },
    { eventType: "content_impression" }
  );
};


export const sendSimilarThisEvent = async ({item, itemDetails}) => {
  console.log("similar this item", item, itemDetails);

  const mediaType = getMediaType(itemDetails?.category_title);

  await sendTestMatomoEvent({
    eventCategory: "SimilarToThis",
    eventAction: "ContentSelected",
    eventName: `(${mediaType})/${item?.id}/${item?.title}`,
    // url: "details",
  });
};
